module.exports = __webpack_public_path__ + "static/media/C1.92bc17f6.jpg";